import { P, S, T } from '../../../styles/tokens';
import { Check, Cross } from './Icons';

interface BulletProps {
  text: string;
}

// Matches prototype TFGood / TFBad: icon inline (no circle bg), footnote text.
// Icons use `currentColor`; wrap in a coloured div to drive the fill.
export function BulletGood({ text }: BulletProps) {
  return (
    <div style={{ display: 'flex', gap: 8, alignItems: 'flex-start' }}>
      <div style={{ height: 19, display: 'flex', alignItems: 'center', flexShrink: 0, color: P.success }}>
        <Check size={14} />
      </div>
      <div style={{ flex: 1, font: T.footnote, color: S.label, lineHeight: '19px' }}>{text}</div>
    </div>
  );
}

export function BulletBad({ text }: BulletProps) {
  return (
    <div style={{ display: 'flex', gap: 8, alignItems: 'flex-start' }}>
      <div style={{ height: 19, display: 'flex', alignItems: 'center', flexShrink: 0, color: P.error }}>
        <Cross size={12} />
      </div>
      <div style={{ flex: 1, font: T.footnote, color: S.label, lineHeight: '19px' }}>{text}</div>
    </div>
  );
}
